import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import { isFlexible, isMetal, isRigid } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"

const isValidSilkColor = (values: EstimateValues, silkColor?: string) => {
  switch (silkColor) {
    case ESTIMATE_CONSTANT.シルク印刷色["白(リジッド)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["黒(リジッド)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["黄(リジッド)"].value:
      return isRigid(values)
    case ESTIMATE_CONSTANT.シルク印刷色["白(フレキシブル)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["黒(フレキシブル)"].value:
      return isFlexible(values)
    case ESTIMATE_CONSTANT.シルク印刷色["白(メタル)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["黒(メタル)"].value:
    case ESTIMATE_CONSTANT.シルク印刷色["黄(メタル)"].value:
      return isMetal(values)

    default:
      return false
  }
}

export default isValidSilkColor
